import chooseContractForChangeModal from "core/chooseContractForChangeModal";

export const ModalFormChooseContractForChange = chooseContractForChangeModal.createContainer(
    chooseContractForChangeModal.FORM_CHOOSE_CONTRACT_FOR_CHANGE,
);
